import { render, staticRenderFns } from "./Navigate.vue?vue&type=template&id=2ae8e2fe&lang=html"
import script from "./Navigate.vue?vue&type=script&lang=js"
export * from "./Navigate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports